import {ReactElement} from 'react'
import {withNamespaces, WithNamespaces, Trans} from 'react-i18next'
import {Table, TableBody, TableCell, TableHead, TableRow, Typography, Grid} from '@material-ui/core'
import messages from '../../../../../../../assets/messages'
import {formatDate} from '../../../../../../../common/utils'
import Amount from '../../../../../../Common/Amount'
import {TablePropsBase} from '../../types'
import {PaidPerformanceAmount} from '../PaidPerformanceAmount'
import {useStyles} from './styles'

const Component = (props: TablePropsBase & WithNamespaces): ReactElement => {
  const {lng, subscriptions, isDefaultDate, children} = props

  const classes = useStyles()

  return (
    <>
      <Table className={classes.container}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.firstColumn}>
              <Trans {...messages.clientName} />
            </TableCell>
            <TableCell><Trans {...messages.startCopyingDate} /></TableCell>
            <TableCell><Trans {...messages.profitPerPeriod} /></TableCell>
            <TableCell><Trans {...messages.stopCopyingDate} /></TableCell>
            <TableCell><Trans {...messages.performanceFeePaid} /></TableCell>
            {isDefaultDate ?
              <TableCell><Trans {...messages.performanceFee} /></TableCell>
            : null}
          </TableRow>
        </TableHead>
        <TableBody>
          {subscriptions.map(subscription => {
            const {
              id,
              followerFullName,
              startedAt,
              stoppedAt,
              profit,
              pendingPerformanceFee,
              currency
            } = subscription

            return (
              <TableRow key={id}>
                <TableCell className={classes.firstColumn}>
                  <Typography variant="body1">
                    {followerFullName ?? '-'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body1">
                    {startedAt != null ? formatDate(lng, startedAt) : '-'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body1">
                    <Amount value={profit} currency={currency} locale='en-US' />
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body1">
                    {stoppedAt != null ? formatDate(lng, stoppedAt) : <Trans {...messages.copying} />}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body1">
                    <PaidPerformanceAmount subscription={subscription} isDefaultDate={isDefaultDate} />
                  </Typography>
                </TableCell>
                {isDefaultDate ? (
                  <TableCell>
                    <Typography variant="body1">
                      <Amount
                        value={pendingPerformanceFee}
                        currency={currency}
                        locale='en-US'
                        classes={{root: classes.yellowText}}
                      />
                    </Typography>
                  </TableCell>
                ) : null}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
      <Grid item container xs={12}>
        {children}
      </Grid>
    </>
  )
}

export const TableDesktop = withNamespaces()(Component)
